export default{
    order:{
        navList:{
            navitem1:'全部订单',
            navitem2:'待确认',
            navitem3:'待付款',
            navitem4:'待发货',
            navitem5:'待备货',
            navitem6:'待收货',
            navitem7:'待自提',
            navitem8:'已完成',
            navitem9:'已取消',
        },
        table:{
            step1:'订单编号：',
            step2:'付款截止：',
            step3:'收货截止：',
            step4:'规格：',
            step5:'查看更多商品',
            step6:'总额',
            step7:'包含',
            step8:'运费',
            step9:'订单信息',
            step10:'合计',
            step11:'订单状态',
            step12:'操作',
            step13:'面议'
        },
        msgState:{
            msg1:'尾款未付',
            msg2:'待商家审核',
            msg3:'进度跟踪',
            msg4:'请前往自提点提货',
            msg5:'商品名称/订单编号',
            msg6:'暂无物流信息'
        },
        btnState:{
            btn1:'确认收货',
            btn2:'取消订单',
            btn3:'确认自提',
            btn4:'删除订单',
            btn5:'订单详情',
            btn6:'取消订单',
            btn7:'立即付款',
            btn8:'售后详情',
            btn9:'申请退款',
            btn10:'支付尾款',
        },
        dialogState:{
            dil1:'订单取消成功后将无法恢复；如使用优惠券，优惠券将不再返还；支付优惠一并取消；已支付金额审核通过后，将原路返回支付账户。',
            dil2:'取消订单',
            dil3:'订单跟踪',
            dil4:'包裹',
            dil5:'配送企业：',
            dil6:'快递单号：',
            dil7:'包裹',
            dil8:'再想想',
            dil9:'提交'
        },
        confirmState:{
            confirm1:'提示',
            confirm2:'确定',
            confirm3:'取消',
            confirm4:'已取消',
            confirm5:'是否删除该订单？',
            confirm6:'订单删除成功!',
            confirm7:'是否确认货品已经收到且根据验收标准确认货品完好',
            confirm8:'已完成收货!',
            confirm9:'订单取消成功',
            confirm10:'是否确认申请验货异议？',
        }

    }
    
}